<template>
	<v-btn
		v-bind="$attrs"
		v-on="$listeners"
		:loading="Authenticating"
		@click="authenticate('googleLogin')"
		large
		outlined
		class="text-transform-none poppins-medium"
		style="border-color: #DCDCDC; border-width: 2px"
	>
		<v-img
			height="30"
			width="30"
			contain
			class="mr-2 flex-grow-0"
			src="https://nutriyouweb.blob.core.windows.net/nutriyouweb/BrandIcons/google_100.png"
		>
		</v-img>
		<span>Continua con Google</span>
	</v-btn>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
	name: "GoogleAuth",
	data() {
		return {
			Authenticating: false
		};
	},
	computed: {
		...mapGetters(["UserProfile", "selectedApplicationId"])
	},
	methods: {
		...mapActions(["snackSuccess", "snackError", "SignInFromOAuth"]),

		async authenticate(provider) {
			try {
				this.Authenticating = true;
				this.$auth.options.providers.googleLogin.url = `GoogleAuth/${this.selectedApplicationId}/GrantPermission`;

				console.log(provider);

				const token = await this.$auth.authenticate(provider);

				console.log("Auth token:", token);

				await this.SignInFromOAuth({
					applicationId: this.selectedApplicationId,
					token: token.data
				});

				this.$emit("authenticated");
			} catch (e) {
				// suppress exception thrown when popup window is closed
				if (e.toString() !== "Error: Auth popup window closed") {
					this.$captureError(e);
					// this.snackError({ Text: this.$t("snackCannotLogin") });
					this.$emit("authentication-error", e);
				}
			} finally {
				this.Authenticating = false;
			}
		}
	}
};
</script>
<style scoped lang="scss"></style>
